module.exports = __webpack_public_path__ + "img/a1ac216.svg";